import React from 'react';

const CreditInvoiceSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="30" height="30">
    <defs>
      <linearGradient id="invoiceGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#ffffff" />
        <stop offset="100%" stopColor="#f5f5f5" />
      </linearGradient>
      <linearGradient id="coinGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#fbbf24" />
        <stop offset="100%" stopColor="#f59e0b" />
      </linearGradient>
      <linearGradient id="headerGrad" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#3b82f6" />
        <stop offset="100%" stopColor="#2563eb" />
      </linearGradient>
    </defs>
    
    {/* Invoice shadow */}
    <rect
      x="10"
      y="6"
      width="40"
      height="54"
      rx="2"
      fill="#000"
      opacity="0.1"
    />
    
    {/* Main invoice document */}
    <rect
      x="8"
      y="4"
      width="40"
      height="54"
      rx="2"
      fill="url(#invoiceGrad)"
      stroke="#d1d5db"
      strokeWidth="1.5"
    />
    
    {/* Header section */}
    <rect
      x="8"
      y="4"
      width="40"
      height="10"
      rx="2"
      fill="url(#headerGrad)"
    />
    
    {/* Invoice title */}
    <text
      x="28"
      y="11"
      fontSize="6"
      fontWeight="bold"
      fill="white"
      textAnchor="middle"
      fontFamily="Arial"
    >
      INVOICE
    </text>
    
    {/* Invoice details lines */}
    <g fill="#6b7280">
      {/* Date and invoice number */}
      <rect x="12" y="18" width="16" height="1.5" rx="0.75" />
      <rect x="12" y="21" width="12" height="1.5" rx="0.75" />
      
      {/* Item list */}
      <rect x="12" y="27" width="22" height="1.5" rx="0.75" />
      <rect x="12" y="31" width="18" height="1.5" rx="0.75" />
      <rect x="12" y="35" width="20" height="1.5" rx="0.75" />
      <rect x="12" y="39" width="16" height="1.5" rx="0.75" />
    </g>
    
    {/* Amount values (right aligned) */}
    <g fill="#374151">
      <rect x="36" y="27" width="8" height="1.5" rx="0.75" />
      <rect x="36" y="31" width="8" height="1.5" rx="0.75" />
      <rect x="36" y="35" width="8" height="1.5" rx="0.75" />
      <rect x="36" y="39" width="8" height="1.5" rx="0.75" />
    </g>
    
    {/* Separator line */}
    <line
      x1="12"
      y1="44"
      x2="44"
      y2="44"
      stroke="#d1d5db"
      strokeWidth="1"
      strokeDasharray="2,2"
    />
    
    {/* Total amount section */}
    <rect
      x="12"
      y="47"
      width="32"
      height="8"
      rx="1"
      fill="#eff6ff"
      stroke="#3b82f6"
      strokeWidth="1"
    />
    
    {/* Total label */}
    <text
      x="14"
      y="52"
      fontSize="5"
      fontWeight="bold"
      fill="#1e40af"
      fontFamily="Arial"
    >
      TOTAL
    </text>
    
    {/* Total amount placeholder */}
    <g fill="#1e40af">
      <rect x="32" y="49" width="3" height="4" rx="0.5" />
      <rect x="36" y="49" width="6" height="4" rx="0.5" />
    </g>
    
    {/* Credit coin overlay */}
    <g>
      {/* Coin shadow */}
      <ellipse
        cx="52"
        cy="44"
        rx="11"
        ry="11"
        fill="#000"
        opacity="0.15"
      />
      
      {/* Main coin */}
      <circle
        cx="50"
        cy="42"
        r="11"
        fill="url(#coinGrad)"
        stroke="#d97706"
        strokeWidth="2"
      />
      
      {/* Inner circle */}
      <circle
        cx="50"
        cy="42"
        r="8"
        fill="none"
        stroke="#f59e0b"
        strokeWidth="1"
        opacity="0.5"
      />
      
      {/* Dollar sign */}
      <text
        x="50"
        y="47"
        fontSize="12"
        fontWeight="bold"
        fill="#92400e"
        textAnchor="middle"
        fontFamily="Arial"
      >
        $
      </text>
      
      {/* Coin shine */}
      <ellipse
        cx="47"
        cy="38"
        rx="4"
        ry="3"
        fill="white"
        opacity="0.4"
      />
    </g>
    
    {/* Corner fold */}
    <path
      d="M 48 4 L 48 8 L 44 8 Z"
      fill="#d1d5db"
    />
  </svg>
);

export default CreditInvoiceSvg;